<template>
  <v-card class="step-card">
    <h3>{{ $t(`registration.firstStep.title`) }}</h3>

    <v-select
      v-model="form.docType"
      :items="documentTypes"
      :label="$t(`registration.firstStep.documentTypeLabel`)"
      outlined
      rounded
      :error="isFieldInvalid('docType')"
      @blur="$v.form.docType.$touch()"
    ></v-select>

    <v-text-field
      v-model="form.docNumber"
      :label="$t(`registration.firstStep.documentNumberLabel`)"
      outlined
      rounded
      maxlength="12"
      type="tel"
      :error="isFieldInvalid('docNumber')"
      @blur="$v.form.docNumber.$touch()"
      @keypress="handleCheckNumber"
    ></v-text-field>

    <v-select
      v-model="form.issued"
      :items="documentIssues"
      :label="$t(`registration.firstStep.organ`)"
      outlined
      rounded
      :error="isFieldInvalid('issued')"
      @blur="$v.form.issued.$touch()"
    ></v-select>

    <v-text-field
      v-model="form.date"
      :label="$t(`registration.firstStep.timeToGive`)"
      type="date"
      outlined
      rounded
      :error="isFieldInvalid('date')"
      @blur="$v.form.date.$touch()"
    ></v-text-field>

    <v-checkbox
      v-model="agreement"
      :label="$t(`registration.firstStep.processingData`)"
      :error="!agreement && touched"
      @change="touched = true"
    ></v-checkbox>

    <NextButton
      @click="handleNextStep"
      :text="$t(`registration.firstStep.nextBtn`)"
    />
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  helpers,
  maxLength,
  minLength,
  required,
} from "vuelidate/lib/validators";
import NextButton from "@/components/custom/NextButton.vue";
import { showToast } from "@/utils/toast";

export default {
  components: { NextButton },
  mixins: [validationMixin],

  data() {
    return {
      documentTypes: ["Удостоверение личности РК", "Паспорт РК", "ВНЖ РК"],
      documentIssues: ["МВД РК", "МЮ РК"],
      agreement: false,
      touched: false,

      form: {
        docType: "",
        docNumber: "",
        issued: "",
        date: "",
      },
    };
  },

  validations: {
    form: {
      docType: { required },
      docNumber: {
        required,
        numericOnly: helpers.regex("numericOnly", /^[0-9]*$/),
        maxLength: maxLength(12),
        minLength: minLength(12),
      },
      issued: { required },
      date: { required },
    },
  },

  computed: {
    isFormValid() {
      return !this.$v.form.$invalid && this.agreement;
    },
  },

  methods: {
    handleNextStep() {
      this.$v.form.$touch();
      this.touched = true;

      if (!this.isFormValid) {
        showToast(this, {
          text: this.$t(`toastText.fields`),
          status: "warning",
          duration: 3000,
        });
        return;
      }

      if (this.isFormValid) {
        this.$emit("nextStep");
      }
    },

    isFieldInvalid(field) {
      return this.$v.form[field].$error;
    },

    handleCheckNumber(e) {
      const char = String.fromCharCode(e.keyCode);
      if (!/[0-9]/.test(char)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.step-card {
  padding: 20px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
}
.step-card h3 {
  font-family: "Montserrat", sans-serif;
}
</style>
